// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'Playfair Display', serif",
    h1: {
      fontFamily: "'Poppins','system-ui','sans-serif'",
    },
    h2: {
      fontFamily: "'Poppins','system-ui','sans-serif'",
    },
    h3: {
      fontFamily: "'Poppins','system-ui','sans-serif'",
    },
  },
  palette: {
    primary: {
      main: "#005F8F",
      light: "#1A7FB2",
      dark: "#004164",
    },
    secondary: {
      main: "#FFB703",
    },
    background: {
      default: "#F9FAFB",
    },
    text: {
      primary: "#111827",
      secondary: "#6B7280",
    },
  },
});

export default theme;
